var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div ng-show=\"$ctrl.formProcessing\" class=\"alert alert-info\"><i class=\"fa fa-refresh fa-spin\"></i> Submitting...</div><div class=\"row\" validation-summary hide-title=\"true\" errors=\"$ctrl.bus.validationErrors\"></div><formio ng-show=\"!$ctrl.formProcessing\" id=\"formiodiv\" form=\"$ctrl.formio.fields\" submission=\"$ctrl.submission\"></formio>";
var id1="form-submission.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;